import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles, THUMBNAIL_BORDER_HEIGHT, THUMBNAIL_HEIGHT } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { CustomShape, makeCustomThumbnailShape, Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { TextileHelper } from '~src/spacesPlatform/utils/TextileHelper';

import { ProjectTooltip } from './ProjectTooltip';

export const PROJECT_THUMBNAIL_HEIGHT = THUMBNAIL_HEIGHT + THUMBNAIL_BORDER_HEIGHT;

export class ProjectCard extends ContentCard {

  public render() {
    const {
      content, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite, inRecycleBinSpace
    } = this.props;
    /*
      Card does not navigate or show FavoriteToggle and PopOver when in Recycle bin space.
    */
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          navigateUrl={inRecycleBinSpace ? null : getContentUrlForItem(content, urls)}
          defaultImageUrl={getAssignedThumbnailImgPath(content.id)}
          thumbnailImageUrl={getThumbnailUrlFromDescription(content.description)}
          hovered={hovered}
          selected={selected}
          imageCoverBackground={true}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
          customHeight={PROJECT_THUMBNAIL_HEIGHT}
          customShape={ProjectCardShape}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          {!inRecycleBinSpace && <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.projectDetails()}
            />
          </span>
          }
          <span>
            {!inRecycleBinSpace && <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'project' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'project' })} />
            }
          </span>
          {this.renderActionsMenu()}
        </div>
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return ProjectTooltip;
  }
}

export function getThumbnailUrlFromDescription(description: string): string {
  const results = TextileHelper.TRAILING_IMAGE.exec(description);
  if (results) {
    return results[1];
  }
  return undefined;
}

export function getAssignedThumbnailImgPath(projectId: string): string {
  // there are three possible default thumbnails for projects
  const index = Number.parseInt(projectId, 10) % 3 + 1;
  const filename = `project-thumb-${index}.png`;
  return imgPath(filename);
}

const folderDrawPath = 'M1 0.5H185.769C185.934 0.5 186.089 0.581331 186.182 0.717384L199.528 20.1957C199.658 20.3861 199.874 20.5 200.105 20.5H299C299.276 20.5 299.5 20.7239 299.5 21V185C299.5 185.276 299.276 185.5 299 185.5H0.999999C0.723857 185.5 0.5 185.276 0.5 185V0.999999C0.5 0.723857 0.723857 0.5 1 0.5Z';
export const ProjectCardShape: CustomShape = makeCustomThumbnailShape(folderDrawPath, 'project-folder-clip-path');
